import React, { useEffect, useState } from 'react';
import BusDialog from './BusDialog';
import { BusFormValues, EditBusDialogProps } from '../types/busTypes';
import { updateBus } from '../utils/utils';
import { SnackbarSeverityType } from '../../../enums';

const EditBusDialog: React.FC<EditBusDialogProps> = ({
  open,
  bus,
  onClose,
  onSuccess,
  showToast
}) => {
  const [values, setValues] = useState<BusFormValues>({
    name: '',
    licensePlateNo: ''
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (bus) {
      setValues({
        name: bus.name || '',
        licensePlateNo: bus.licensePlateNo || ''
      });
    }
  }, [bus]);

  const handleChange = (field: keyof BusFormValues, value: string) => {
    setValues((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    if (!bus) return;
    try {
      setLoading(true);
      await updateBus(bus, values);
      showToast('Bus updated', SnackbarSeverityType.success);
      onClose();
      onSuccess();
    } catch (e: any) {
      showToast(
        e?.message || 'Failed to update bus',
        SnackbarSeverityType.error
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDialogClose = () => {
    if (loading) return;
    onClose();
  };

  if (!bus) return null;

  return (
    <BusDialog
      open={open}
      title='Update Bus Details'
      submitLabel='Save Changes'
      values={values}
      errors={{}}
      loading={loading}
      onClose={handleDialogClose}
      onChange={handleChange}
      onSubmit={handleSubmit}
      busId={bus._id || bus.id}
    />
  );
};

export default EditBusDialog;
